import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
//Estilo que muestra un rectangulo que parece boton
const style = {
    display: "inline-block",
    padding: "6px 12px",
    marginBottom: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    border: "1px solid transparent",
    borderRadius: "4px",
    color: "#333",
    backgroundColor: "rgba(100,100,100, 0.1)",
    borderColor: "#ccc"
};

export class UltimoEscaneoComponent extends React.PureComponent<{ value: models.UltimaLecturaFolioFisico | null, idCargaDescarga: number }> {
    render() {
        const { value, idCargaDescarga } = this.props;
        if (value == null || value.idCargaDescarga != idCargaDescarga) {
            return (
                <div className="alert alert-info">
                    <label>Ninguno</label>
                    <br />
                    Escanee un paquete o sobre para mostrar el ultimo servicio incluido
                </div>
            );
        }
        return (
            <div style={{ ...style }}>
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "1 0 auto" }} />
                    <div style={{ flex: "0 1 auto" }} >
                        <span style={{ fontFamily: "monospace", fontSize: "18px", fontWeight: "bold" }}>
                            {value.lectura.FolioGuia}
                        </span>
                    </div>
                    <div style={{ flex: "1 0 auto" }} />
                </div>

                <div style={{ display: "flex" }}>
                    <div style={{ flex: "1 0 auto" }} />
                    <div style={{ flex: "0 1 auto" }} >
                        <span style={{ fontStyle: "italic" }}>
                            <i className={value.lectura.Tipo == models.TipoFolioFisico.Paquete ? fa("cubes", "fw") : fa("envelope-o", "fw")} />
                            {models.TipoFolioFisico[value.lectura.Tipo]}
                        </span>
                    </div>
                    <div style={{ flex: "1 0 auto" }} />
                </div>

                <div style={{ display: "flex" }}>
                    <div style={{ flex: "1 0 auto" }} />
                    <div style={{ flex: "0 1 auto" }} >
                        <span style={{ fontSize: "24px" }}>
                            {value.lectura.NumeroFisico}/{value.lectura.TotalNumerosFisicos}
                        </span>
                    </div>
                    <div style={{ flex: "1 0 auto" }} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/features/componentes/cargas/ultimoescaneo.tsx